import '../../core/styles/focusRingStatic.css';
import './ExternalLink.css';
export var externalLink = '_1v1skpy0-3-12-1 _z0fq9b4-3-12-1 _z0fq9be-3-12-1 _z0fq9b5-3-12-1 _z0fq9b9-3-12-1';